// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "mail." + chunkId + "." + {"66":"33c51932b2dffa71f78d","327":"864b2535b5842a9a1989","471":"5ddda6d4a08c14c3d5f0","862":"47376b9a7449896c39ae","932":"c31053bbc090a3ae58ec"}[chunkId] + ".js";
};